export enum SettingType {
  OutsideSurveyPreValidationBuildingLOM = 1,
  OutsideSurveyPreValidationAddressLOM = 2,
  OutsideSurveyPreValidationBuildingIFH = 3,
  OutsideSurveyPreValidationGroupIFH = 4,
  InsideSurveyPreValidationBuildingLOM = 5,
  InsideSurveyPreValidationAddressLOM = 6,
  InsideSurveyPreValidationBuildingIFH = 7,
  InsideSurveyPreValidationGroupIFH = 8,
}
